module.exports = __webpack_public_path__ + "img/shandong_service_qr_code.f70d3094.png";